import { Alert } from "@mui/material";

export default function NotFound(){

    return (
        <Alert severity='info'>Il n'y a pas d'EPP dans cette formation. 😌</Alert>
    )
}